import React, { Component } from "react"
import { Input, Card, Dropdown, Icon } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { addProductApi } from "../config/apiUrls"
import { apiPost } from "../utils/apiConnector"
import { getMeasures } from "../ducks/measures"

const friendOptions = [
  {
    key: "Jenny Hess",
    text: "Jenny Hess",
    value: "Jenny Hess",
  },
]

@withTranslation()
@connect(
  (state) => {
    return { profile: state.profile, measures: state.measures }
  },
  (dispatch) => ({
    getMeasures: () => {
      dispatch(getMeasures())
    },
  }),
)
class AddProductComponent extends Component {
  state = {
    title: "",
    barcode: "",
    measure: "",
    createMeasures: [],
    storeId: "",
    purchaseprice: "",
    saleprice: "",
  }

  componentDidMount() {
    this.props.getMeasures()
  }

  saveNewProduct = () => {
    const storeId = this.props.profile.currentStore.id
    const purchaseprice = this.state.purchaseprice
    const saleprice = this.state.saleprice
    const measures = []
    const measure = this.state.measure
    if (measure) {
      const m = {}
      m.measureId = parseInt(measure.id)
      m.coef = 1
      m.isDefault = true
      m.price = parseInt(saleprice)
      m.purchasePrice = parseInt(purchaseprice)
      measures.push(m)
    }
    const toSend = {
      storeId: storeId,
      name: this.state.title,
      barcode: this.state.barcode,
      measures: measures,
    }

    // console.log("Create ", create);
    // console.log("data ", data);
    apiPost(addProductApi, toSend)
      .onOk((res) => {
        console.log(res.data.response)
      })
      .onFail((res) => {
        console.log(res)
      })
      .startSingle()
  }

  render() {
    const { t } = this.props
    return (
      <>
        <Card style={{ width: "max-content" }}>
          <Card.Header>
            <h3 style={{ margin: 10, marginLeft: 20 }}>
              {t("Add new product")}:
            </h3>
          </Card.Header>
          <Card.Content>
            <div>
              <p>{t("title")}:</p>
              <Input
                onChange={(e, d) => {
                  this.setState({ title: d.value })
                }}
              />
              <p></p>
              <div style={{ display: "flex" }}>
                <div>
                  <p>{t("barcode")}:</p>
                  <Input
                    onChange={(e, d) => {
                      this.setState({ barcode: d.value })
                    }}
                  />
                </div>
                <span style={{ display: "inline-block", width: 20 }}></span>
                <div>
                  <p>{t("unitsMeasuringFull")}</p>
                  <Dropdown
                    // options={friendOptions}
                    options={this.props.measures.measures.map((q) => {
                      const r = {}
                      r.key = q.id
                      r.text = q.name
                      r.value = q
                      return r
                    })}
                    onChange={(e, d) => {
                      console.log(d.value)
                      const measure = d.value
                      this.setState({ measure: measure })
                    }}
                  />
                </div>
              </div>
              <p></p>
              {/* 
                <Input type="checkbox" />
              {t("base")}
              */}
              <p></p>
              <Input
                placeholder={t("purchaseprice")}
                onChange={(e, d) => {
                  this.setState({ purchaseprice: d.value })
                }}
              />
              <span style={{ display: "inline-block", width: 20 }}></span>
              <Input
                placeholder={t("saleprice")}
                onChange={(e, d) => {
                  this.setState({ saleprice: d.value })
                }}
              />
              <p></p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 10,
                }}
              >
                <Icon
                  name="add"
                  size="large"
                  color="green"
                  onClick={() => {
                    this.saveNewProduct()
                  }}
                />
              </div>
            </div>
          </Card.Content>
        </Card>
      </>
    )
  }
}

export default AddProductComponent
